import { showPasswordToggler } from 'landing-components/show-password-button'
import { handleForm } from 'landing-components/input-form'
import { initRatesWidget } from 'landing-components/four-main-currencies-widget'
import { spawnTrackingEventListners } from 'components/tracking-ga-events'

function init(): void {
  // Init 4 main currency widget
  initRatesWidget()

  // Add show password behavior
  showPasswordToggler()

  // Registry Form
  handleForm()

  // set GA/GTM events tracking
  spawnTrackingEventListners()
}

init()
